import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { TargetIcon, ShieldCheckIcon, CalendarCheckIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function SystemSection() {
  const phases = [{
    id: 'FASE 1',
    title: 'ATRACCIÓN DE ALTO VALOR',
    icon: TargetIcon,
    body: 'Encontramos personas y empresas en proceso de mudanza en tu zona que priorizan confianza y profesionalismo sobre el precio más bajo. Mudanzas de $800 a $5,000+. No clientes de $200.'
  }, {
    id: 'FASE 2',
    title: 'BLINDAJE DE REPUTACIÓN',
    icon: ShieldCheckIcon,
    body: 'Construimos tu autoridad online con reseñas verificadas y un sistema de respuesta a comentarios que convierte críticas en prueba de tu profesionalismo.'
  }, {
    id: 'FASE 3',
    title: 'RESERVA CON DEPÓSITO AUTOMÁTICO',
    icon: CalendarCheckIcon,
    body: 'El sistema recibe la solicitud, da el estimado automático, cobra el depósito y agenda la fecha. Sin que tú tengas que hacer nada.'
  }];
  return <section className="w-full py-20 md:py-24 px-6 flex justify-center bg-carbon" data-id="element-252">
      <div className="max-w-6xl w-full" data-id="element-253">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-254">
          <span className="text-gold text-sm md:text-base font-bold tracking-widest uppercase mb-4 block" data-id="element-255">
            SISTEMA A.C.E.™ MOVING
          </span>
          <h2 className="text-gold text-4xl sm:text-5xl lg:text-6xl font-bold" data-id="element-256">
            La Cura
          </h2>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-257">
          {phases.map(phase => {
          const Icon = phase.icon;
          return <motion.div key={phase.id} variants={cardVariants} className="bg-surface border border-border p-8 rounded-xl flex flex-col items-start relative overflow-hidden group hover:border-gold/30 transition-colors duration-300" data-id="element-258">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-259" />

                <div className="flex items-center gap-4 mb-6 w-full" data-id="element-260">
                  <div className="bg-carbon p-3 rounded-lg border border-border" data-id="element-261">
                    <Icon className="w-8 h-8 text-gold" data-id="element-262" />
                  </div>
                  <span className="text-gold font-mono font-bold text-sm tracking-widest" data-id="element-263">
                    {phase.id}
                  </span>
                </div>

                <h3 className="text-light text-xl font-bold mb-4 leading-tight" data-id="element-264">
                  {phase.title}
                </h3>

                <p className="text-muted text-base leading-relaxed" data-id="element-265">
                  {phase.body}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}